<template>
  <DropdownComponent class="shop-pricing-method" :close-on-click="false" @visible="$emit('track', 'PricingMethod')">
    <template #default>
      <ButtonComponent :icon="['fal', 'calculator']">
        <template #label>
          <div class="col top text--small">
            <span style="font-size: 0.8em">{{ $t('priceCalculation') }}</span>
            <strong>{{ $t(`helpers:shopPricingMethodTitle:${value}`) }}</strong>
          </div>
        </template>
      </ButtonComponent>
    </template>
    <template #dropdown>
      <InputComponent :label="$t('selectMethod')">
        <template #after-label>
          <Helper>
            <template #body>
              <template v-for="item in items">
                <strong :key="'title_' + item.value">{{ $t(`helpers:shopPricingMethodTitle:${item.value}`) }}</strong>
                <p :key="'desc_' + item.value" class="mt-0">
                  {{ $t(`helpers:shopPricingMethodDescription:${item.value}`) }}
                </p>
              </template>
            </template>
          </Helper>
        </template>
        <template #default>
          <Radio :value="value" @input="$ev => $emit('input', $ev)" :items="items" />
        </template>
      </InputComponent>
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import { ButtonComponent } from 'vue-elder-button'
import { InputComponent } from 'vue-elder-input'
import Radio from '@kvass/radio'
import Helper from '@/components/HelperPopover'

export default {
  props: {
    value: String,
  },
  data() {
    return {
      items: [
        { value: 'add', label: this.$t('helpers:shopPricingMethodTitle:add') },
        { value: 'diff', label: this.$t('helpers:shopPricingMethodTitle:diff') },
      ],
    }
  },
  methods: {},
  components: {
    DropdownComponent,
    ButtonComponent,
    Radio,
    Helper,
    InputComponent,
  },
}
</script>

<style lang="scss">
.shop-pricing-method {
  .kvass-radio {
    padding: 1rem;
    flex-direction: column;
  }

  .elder-dropdown__content-box {
    padding: 1rem;
  }
}
</style>
